module.exports = __webpack_public_path__ + "static/media/anc16ru.c20b6418.pdf";